if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        let submitButton = this.submitButton;
        let cartDrawer = this.cart;
        let handleErrorMessageFunc = this.handleErrorMessage();
        let loadindSpinner = this.querySelector(".loading__spinner");
        let error = this.error;
        let btn_id = submitButton.getAttribute("data-id");
        let productForm = this.form;
        let addData = true;

        var cartContents = fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((data) => {
            console.log("data", data);
            if (data.item_count == 0) {
              console.log("empty cart");
              if (submitButton.getAttribute("aria-disabled") === "true") return;

              handleErrorMessageFunc;

              submitButton.setAttribute("aria-disabled", true);
              submitButton.classList.add("loading");
              loadindSpinner.classList.remove("hidden");

              const config = fetchConfig("javascript");
              config.headers["X-Requested-With"] = "XMLHttpRequest";
              delete config.headers["Content-Type"];

              console.log("productForm--", productForm);
              const formData = new FormData(productForm);
              console.log("formData--", formData);
              if (cartDrawer) {
                formData.append(
                  "sections",
                  cartDrawer.getSectionsToRender().map((section) => section.id)
                );
                formData.append("sections_url", window.location.pathname);
                cartDrawer.setActiveElement(document.activeElement);
              }
              config.body = formData;
              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    console.log("if---");
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: "product-form",
                      productVariantId: formData.get("id"),
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    this.handleErrorMessage(response.description);

                    const soldOutMessage =
                      submitButton.querySelector(".sold-out-message");
                    if (!soldOutMessage) return;
                    submitButton.setAttribute("aria-disabled", true);
                    submitButton.querySelector("span").classList.add("hidden");
                    soldOutMessage.classList.remove("hidden");
                    error = true;
                    return;
                  } else if (!cartDrawer) {
                    console.log("else if---");
                    window.location = window.routes.cart_url;
                    return;
                  }

                  if (!error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: "product-form",
                      productVariantId: formData.get("id"),
                      cartData: response,
                    });
                  cartDrawer.renderContents(response);

                  error = false;
                  const quickAddModal = this.closest("quick-add-modal");
                  if (quickAddModal) {
                    document.body.addEventListener(
                      "modalClosed",
                      () => {
                        setTimeout(() => {
                          cartDrawer.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    cartDrawer.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  submitButton.classList.remove("loading");
                  if (cartDrawer && cartDrawer.classList.contains("is-empty"))
                    cartDrawer.classList.remove("is-empty");
                  if (!error) submitButton.removeAttribute("aria-disabled");
                  loadindSpinner.classList.add("hidden");
                });
            } else {
              data.items.forEach(function (i, item) {
                console.log("i==", i);
                console.log("item", item);
                console.log("i.id", i.id);
                console.log("btn_id", btn_id);
                if (i.id.toString() == btn_id) {
                  console.log("id matched");
                  if (i.quantity >= 4) {
                    addData = false;
                  } else {
                    addData = true;
                  }
                  return;
                }
              });

              if (addData == true) {
                if (submitButton.getAttribute("aria-disabled") === "true")
                  return;

                handleErrorMessageFunc;

                submitButton.setAttribute("aria-disabled", true);
                submitButton.classList.add("loading");
                loadindSpinner.classList.remove("hidden");

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                console.log("productForm--", productForm);

                const formData = new FormData(productForm);
                console.log("formData---", formData);
                if (cartDrawer) {
                  formData.append(
                    "sections",
                    cartDrawer
                      .getSectionsToRender()
                      .map((section) => section.id)
                  );
                  formData.append("sections_url", window.location.pathname);
                  cartDrawer.setActiveElement(document.activeElement);
                }
                config.body = formData;
                fetch(`${routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                      console.log("if---");
                      publish(PUB_SUB_EVENTS.cartError, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                        errors: response.errors || response.description,
                        message: response.message,
                      });
                      this.handleErrorMessage(response.description);

                      const soldOutMessage =
                        submitButton.querySelector(".sold-out-message");
                      if (!soldOutMessage) return;
                      submitButton.setAttribute("aria-disabled", true);
                      submitButton
                        .querySelector("span")
                        .classList.add("hidden");
                      soldOutMessage.classList.remove("hidden");
                      error = true;
                      return;
                    } else if (!cartDrawer) {
                      console.log("else if---");
                      window.location = window.routes.cart_url;
                      return;
                    }

                    if (!error)
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                        cartData: response,
                      });
                    cartDrawer.renderContents(response);

                    error = false;
                    const quickAddModal = this.closest("quick-add-modal");
                    if (quickAddModal) {
                      document.body.addEventListener(
                        "modalClosed",
                        () => {
                          setTimeout(() => {
                            cartDrawer.renderContents(response);
                          });
                        },
                        { once: true }
                      );
                      quickAddModal.hide(true);
                    } else {
                      cartDrawer.renderContents(response);
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                  })
                  .finally(() => {
                    submitButton.classList.remove("loading");
                    if (cartDrawer && cartDrawer.classList.contains("is-empty"))
                      cartDrawer.classList.remove("is-empty");
                    if (!error) submitButton.removeAttribute("aria-disabled");
                    loadindSpinner.classList.add("hidden");
                  });
              }
            }
          });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
